import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from "@mui/material"
import Zoom from '@mui/material/Zoom';
import RtspPlayer from 'components/RtspPlayer';
import { getWebsocketHost, settingsConfig } from 'utils/commonFunc';
import { isSupported } from 'utils/mediasource-helper';
import styles from "../css/gis.module.css"

export const PopupViewCctv = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)
    const [url, setUrl] = React.useState()

    // 오버플로우 상태를 추적할 ref와 state
    const nmRef = React.useRef(null);
    const idRef = React.useRef(null);
    const [nmOverflow, setNmOverflow] = React.useState(false);
    const [idOverflow, setIdOverflow] = React.useState(false);

    React.useEffect(() => {
        setTransitionIn(false);
        const key = setTimeout(() => {
          setTransitionIn(true);

    // DOM이 확실히 렌더링된 후 측정
    if (nmRef.current) {
        const nmEl = nmRef.current;
        const overflow = nmEl.scrollWidth > nmEl.clientWidth;
        console.log("nmRef", { scrollWidth: nmEl.scrollWidth, clientWidth: nmEl.clientWidth, overflow });
        setNmOverflow(overflow);
      }
      if (idRef.current) {
        const idEl = idRef.current;
        const overflow = idEl.scrollWidth > idEl.clientWidth;
        console.log("idRef", { scrollWidth: idEl.scrollWidth, clientWidth: idEl.clientWidth, overflow });
        setIdOverflow(overflow);
      }
    }, 400); // Zoom in 이후에 측정되도록 타이밍 확보
  
    return () => clearTimeout(key);
  }, [item.id, item.nm]);

    React.useEffect(() => {
        if(item.id) {
            const serviceConfig = settingsConfig()
            setUrl(`${getWebsocketHost('/websocket/stream', serviceConfig.wsPortCctv)}?id=${item.id}&width=${serviceConfig.cctvWidth}&height=${serviceConfig.cctvHeight}&fps=${serviceConfig.cctvFps}`)
        }
    }, [item])

    return (
        <Zoom in={transitionIn} timeout={500} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${styles.gisPopup_cctv} gisPopup flx flx_col gap6`} style={{width:'520px'}}>
                <div className='flx a_center'>
                    <div className='popTit'>CCTV </div>
                    <span className='id'>{item.nm}</span>
                </div>
                <div>
                    <RtspPlayer url={url} fps={settingsConfig().cctvFps}/>
                </div>
                <div className='flx gap20'>
                    <div className='flx flx_col' style={{width:'50%', gap:'20px'}}>
                        <div className='flx a_center j_spc_btw'>
                            <div className={`${styles.gisPopTit_cctv}`}>상태</div>
                            {item.stat == 1 ? <div className='gr'>정상</div> : <div className='rd'>장애</div>}
                        </div>
                        <div className='flx a_center j_spc_btw'>
                            <div className={`${styles.gisPopTit_cctv}`}>ID</div>
                            <div className=''>{item.id}</div>
                        </div>
                    </div>
                    <div style={{width:'50%'}}>
                        <img style={{width:'100%', height:'100%'}} src='/images/facility/cctv_thumbnail.jpg'/>
                    </div>
                </div>
            </div>            
        </Zoom>
    )
}